module.exports = __webpack_public_path__ + "img/WPSC.3a521538.png";